import { render } from "./carUserinfoCollect.vue?vue&type=template&id=55d84802"
const script = {}

import "./carUserinfoCollect.vue?vue&type=style&index=0&id=55d84802&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__